
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.007 14h3.325v-1.333c0-1.188-.322-2.926-2-3.911V14H10V8.224a6.926 6.926 0 00-.746-.143l-.586.586.666 2.667L8 13.236l-1.333-1.902.666-2.667-.586-.586c-.258.035-.5.081-.727.137L6 8.224V14H4.665V8.755c-1.678.985-2 2.723-2 3.912v1.334H10.006zM7.999 4.004h-2.31a2.336 2.336 0 002.31 2.664 2.336 2.336 0 002.309-2.666h-.976l-.667-.665L8 4.003zm0-3.336a3.671 3.671 0 013.666 3.667 3.655 3.655 0 01-1.152 2.662c2.637.746 4.152 2.747 4.152 5.671v2.667H1.332v-2.667c0-2.924 1.515-4.925 4.153-5.671a3.655 3.655 0 01-1.153-2.662A3.671 3.671 0 017.999.667z","fill":"#2A333D"}})])
          )
        }
      }
    